import React from "react";
import Avatar from "./ui/Avatar";
import {formatTimeControl, timeCategory} from "../utils/chessFunctions";
import {TimeVariants} from "../utils/gameEnums";

const categoryInfo = (offer) => {
    const key = timeCategory(offer.baseTime, offer.increment);
    return Object.values(TimeVariants).find((variant) => variant.value === key) || TimeVariants.RAPID;
};

// Which colour YOU end up with for a given offer
const colorForViewer = (offer, isOwnOffer) => {
    if (offer.selectedColor === "random" || !offer.selectedColor) return "random";
    if (isOwnOffer) return offer.selectedColor;
    return offer.selectedColor === "white" ? "black" : "white";
};

export const OfferMeta = ({offer, isOwnOffer}) => {
    const category = categoryInfo(offer);
    const isJumpstart = offer.variant === "jumpstart";
    const viewerAhead = offer.isCreatorsHandicap === isOwnOffer;
    return (
        <div className="offer-row__meta">
            <span className="chip"><img src={category.imageSrc} alt=""/>{formatTimeControl(offer.baseTime, offer.increment)} · {category.title}</span>
            {isJumpstart ? (
                <>
                    <span className="chip chip--blossom" title="Jumpstart: the game starts from a random position">Jumpstart</span>
                    <span className={`chip ${viewerAhead ? "chip--sun" : "chip--lake"}`}
                          title={`Evaluation ${offer.lower_eval_limit}-${offer.upper_eval_limit}, moves ${offer.lower_move_limit}-${offer.upper_move_limit}`}>
                        <img src={viewerAhead ? "/leader.png" : "/challenger.png"} alt=""/>
                        {viewerAhead ? "You start ahead" : "You start behind"}
                    </span>
                </>
            ) : (
                <span className="chip chip--leaf">Standard</span>
            )}
        </div>
    );
};

const LobbyCard = ({offer, onClick, isOwnOffer, onCancel, actionLabel = "Play"}) => {
    const name = offer.username || "Guest player";
    const viewerColor = colorForViewer(offer, isOwnOffer);

    if (isOwnOffer) {
        return (
            <div className="offer-row offer-row--own">
                <span className="spinner spinner--sm" aria-hidden="true"/>
                <div className="offer-row__main">
                    <div className="offer-row__name">Waiting for an opponent…</div>
                    <OfferMeta offer={offer} isOwnOffer={true}/>
                </div>
                {onCancel && <button className="btn btn-sm" onClick={onCancel}>Cancel</button>}
            </div>
        );
    }

    return (
        <button type="button" className="offer-row" onClick={onClick}>
            <Avatar name={name} size={34} guest={!offer.username}/>
            <div className="offer-row__main">
                <div className="offer-row__name">{name}</div>
                <OfferMeta offer={offer} isOwnOffer={false}/>
            </div>
            <span className={`color-pip color-pip--${viewerColor}`}
                  title={viewerColor === "random" ? "Random colour" : `You play ${viewerColor}`}/>
            <span className="offer-row__cta">{actionLabel}</span>
        </button>
    );
}

export default LobbyCard;
